import { render, staticRenderFns } from "./AppSettingsParentCommsOOA.vue?vue&type=template&id=13076c0d&"
import script from "./AppSettingsParentCommsOOA.vue?vue&type=script&lang=js&"
export * from "./AppSettingsParentCommsOOA.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsParentCommsOOA.vue?vue&type=style&index=0&id=13076c0d&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports